import React from 'react';
import styled from 'styled-components';
import { Create } from 'react-admin';
import PortalBuilder from '~/Components/PortalBuilder';

const StyledCreate = styled(Create)`
  height: 100%;
  margin: 0;
  > div {
    height: 100%;
    margin: 0;
    > .MuiPaper-root {
      box-shadow: none;
    }
  }
`;

export const PortalEditor = ({ resource, ...props }: any) => {
  return (
    <StyledCreate resource={resource} actions={null} undoable={false} {...props}>
      <PortalBuilder onCancel={() => props.history.push(`/captive_portal_v3`)} />
    </StyledCreate>
  );
};

export default PortalEditor;
